<script setup>
import EventPreviewPage from '@/views/setup/events/preview/EventPreviewPage.vue'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import HorizontalEventsMenu from '@/components/Menus/Events/HorizontalEventsMenu.vue'

definePage({ meta: { ...PageMeta.Events.Preview.Meta, pageTitle: PageMeta.Events.Preview.Title } })

const route = useRoute()

/* ** */
</script>

<template>
  <section>
    <!-- Horizontal Menu / Navigation -->
    <VRow>
      <VCol cols="12">
        <HorizontalEventsMenu :event-g-u-i-d="route.params.guid" />
      </VCol>
    </VRow>

    <!-- Page -->
    <VRow>
      <VCol cols="12">
        <EventPreviewPage
          v-if="route.params.guid"
          :event-g-u-i-d="route.params.guid"
        />
      </VCol>
    </VRow>
  </section>
</template>
